class ScoreFeedbackModal {
  constructor() {
    this.modal = null;
    this.form = null;
    this.selectedScore = null;
    this.submitButton = null;
    this.scoreButtons = null;
    
    this.init();
  }
  
  init() {
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setupModal());
    } else {
      this.setupModal();
    }
  }
  
  setupModal() {
    this.modal = document.getElementById('scoreFeedbackModal');
    this.form = document.getElementById('score-feedback-form');
    this.submitButton = document.getElementById('submit-feedback-btn');
    this.scoreButtons = document.querySelectorAll('.score-btn');
    
    // Only proceed if we have the specific score feedback modal elements
    if (!this.modal || !this.form || this.form.id !== 'score-feedback-form') {
      return; // Modal not present or not the correct form
    }
    
    this.bindEvents();
    this.checkShouldShowModal();
  }
  
  bindEvents() {
    // Handle score button clicks
    this.scoreButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        this.selectScore(e.target.dataset.score);
      });
    });
    
    // Handle form submission - only for the score feedback form specifically
    if (this.form && this.form.id === 'score-feedback-form') {
      this.form.addEventListener('submit', (e) => {
        e.preventDefault();
        this.submitFeedback();
      });
    }
    
    // Handle modal close events
    this.modal.addEventListener('hidden.bs.modal', () => {
      this.markModalShown();
    });
  }
  
  selectScore(score) {
    this.selectedScore = score;
    
    // Update UI
    this.scoreButtons.forEach(btn => {
      btn.classList.remove('btn-primary');
      btn.classList.add('btn-outline-primary');
    });
    
    const selectedButton = document.querySelector(`[data-score="${score}"]`);
    selectedButton.classList.remove('btn-outline-primary');
    selectedButton.classList.add('btn-primary');
    
    // Update hidden field and enable submit button
    document.getElementById('selected-score').value = score;
    this.submitButton.disabled = false;
  }
  
  async submitFeedback() {
    const formData = new FormData(this.form);
    const scoreValue = document.getElementById('selected-score').value;
    const reasonValue = document.getElementById('score_feedback_reason').value;
    
    // Prepare data for submission
    const data = {
      score_feedback: {
        score: parseInt(scoreValue),
        reason: reasonValue
      }
    };
    
    try {
      this.submitButton.disabled = true;
      this.submitButton.textContent = 'Enviando...';
      
      const response = await fetch('/score_feedbacks', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
        },
        body: JSON.stringify(data)
      });
      
      const result = await response.json();
      
      if (result.status === 'success') {
        this.showSuccessMessage(result.message);
        this.markModalShown();
        setTimeout(() => this.hideModal(), 2000);
      } else {
        this.showErrorMessage(result.errors?.join(', ') || 'Erro ao enviar feedback');
        this.submitButton.disabled = false;
        this.submitButton.textContent = 'Enviar Feedback';
      }
    } catch (error) {
      console.error('Error submitting feedback:', error);
      this.showErrorMessage('Erro ao enviar feedback. Tente novamente.');
      this.submitButton.disabled = false;
      this.submitButton.textContent = 'Enviar Feedback';
    }
  }
  
  showSuccessMessage(message) {
    const modalBody = this.modal.querySelector('.modal-body');
    modalBody.innerHTML = `
      <div class="alert alert-success text-center">
        <i class="fas fa-check-circle fa-2x mb-2"></i>
        <p class="mb-0">${message}</p>
      </div>
    `;
    this.modal.querySelector('.modal-footer').style.display = 'none';
  }
  
  showErrorMessage(message) {
    // Remove any existing alerts
    const existingAlert = this.modal.querySelector('.alert');
    if (existingAlert) {
      existingAlert.remove();
    }
    
    const alertDiv = document.createElement('div');
    alertDiv.className = 'alert alert-danger';
    alertDiv.textContent = message;
    
    this.modal.querySelector('.modal-body').prepend(alertDiv);
  }
  
  async checkShouldShowModal() {
    // Don't show if already shown in this session
    if (sessionStorage.getItem('scoreFeedbackModalShown')) {
      return;
    }
    
    try {
      const response = await fetch('/score_feedbacks/should_show_modal');
      const result = await response.json();
      
      if (result.show_modal) {
        // Delay showing the modal by 3 seconds after page load
        setTimeout(() => this.showModal(), 3000);
      }
    } catch (error) {
      console.error('Error checking modal status:', error);
    }
  }
  
  showModal() {
    if (this.modal) {
      const bootstrapModal = new bootstrap.Modal(this.modal);
      bootstrapModal.show();
    }
  }
  
  hideModal() {
    if (this.modal) {
      const bootstrapModal = bootstrap.Modal.getInstance(this.modal);
      if (bootstrapModal) {
        bootstrapModal.hide();
      }
    }
  }
  
  markModalShown() {
    sessionStorage.setItem('scoreFeedbackModalShown', 'true');
  }
}

// Initialize the modal when this script loads
export default ScoreFeedbackModal; 